import Cookies from 'js-cookie'
import { OAUTH_PENDING_KEY } from './oauth'

// 仅移除认证数据，保留语言偏好等无关本地配置。
export function clearLoginSession() {
  const keys = ['access_token', 'refresh_token', 'accessToken', 'refreshToken', 'token', 'useInfo', 'memcore.auth.token', 'memcore.auth.user']
  keys.forEach((key) => {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
    Cookies.remove(key)
  })
  sessionStorage.removeItem(OAUTH_PENDING_KEY)
}

export function removeAllLocal() {
  return localStorage.clear()
}

//清除所有cookie
export function clearCookie() {
  const cookies = document.cookie.match(/[^ =;]+(?==)/g)
  if (cookies) {
    cookies.forEach(function (cookie) {
      Cookies.remove(cookie)
    })
  }
}
